<template>
<div class="EventList">
    <div class="table-container">
        <el-table :data="tableData">
            <el-table-column :label="$t(/*上报时间*/'event.report_time')">
                <template slot-scope="{row}">{{$U.timeFormat(row.create_time)}}</template>
            </el-table-column>
            <el-table-column :label="$t(/*事件类型*/'event.event_type')">
                <template slot-scope="{row}">
                    <div class="status-bg tab" :class="$U.eventTypeFilter(row.type, 'color')">
                        {{$t($U.eventTypeFilter(row.type))}}
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="paging-container with-btn">
        <el-button @click="pageChange(1)">{{$t(/*刷新*/'c.refresh')}}</el-button>
        <el-pagination
            @current-change="pageChange"
            :current-page="currPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
import Core from '../../../core'

export default {
    components: {},
    props: {
        uid: { type: [String] },
        id:  { type: [String, Number] },
        space: { type: [String, Number] },
        detail: { type: Object, default: () => {}},
    },
    data() {
        return {
            tableData: [],
            currPage: 1,
            pageSize: 10,
            total: 0
        }
    },
    watch: {},
    computed: {},
    mounted() {
        this.pageChange(1)
    },
    methods: {
        getTableData() {
            Core.Api.Device.eventList({
                space: this.space,
                uid: this.uid,
                page: this.currPage
            }).then(res => {
                this.tableData = res.device_event_list
                this.total = res.count;
            });
        },
        pageChange(page) {
            this.currPage = page;
            this.getTableData();
        }
    },
}
</script>

<style lang='scss' scoped>
// .EventList {}
</style>